/** First season offered by the archive year filter; the list runs from it to the current year. */
export const TOURNAMENT_ARCHIVE_FIRST_SEASON = 2024;

/** Search field in the tournament list toolbars — hidden for now; flip to bring it back. */
export const TOURNAMENT_LIST_SEARCH_ENABLED = false;

// Favorite tournaments: one independent set of marks per list
export const TOURNAMENT_FAVORITE_LISTS = {
  MY: 'my',
  PUBLIC: 'public',
} as const;

export type TournamentFavoriteList = typeof TOURNAMENT_FAVORITE_LISTS[keyof typeof TOURNAMENT_FAVORITE_LISTS];

export const MAX_FAVORITE_TOURNAMENTS_PER_LIST = 5;
